




import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'UserStatusChip',
  props: {
    status: {
      type: String,
      default: '',
    },
  },
  computed: {
    color(): string {
      if (this.status === 'deactivated') return 'red'
      if (this.status === 'activated') return 'green'

      return 'orange'
    },
  },
})
